import React, { ReactElement, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

// evertel
import { Button, HeaderAlert, Icon, useUI } from '../'
import { useService } from '@evertel/di'
import { PushService } from '@evertel/push'
import { Links } from '@evertel/constants'
import { isEdgeBrowser } from '@evertel/web/utils'

export interface PermissionAlertBarProps {
    type: string
    isOpen: boolean
}


const PermissionAlert: React.FC<PermissionAlertBarProps> = observer(({
    type,
    isOpen
}) => {

    const pushService = useService(PushService, [])
    const { closeAlertBar } = useUI()


    const [message, setMessage] = useState<ReactElement | undefined>(undefined)
    const [color, setColor] = useState<string | undefined>('')

    useEffect(() => {
        defineMessage()
    }, [type])


    const refresh = () => {
        document.location.reload()
    }

    const enableNotifications = async () => {
        if ('Notification' in window) {
            // if they have denied notifications, open the help article on how to enable
            if (pushService?.notificationPermission === 'denied') {
                goTo('help-notifications')

            } else if (isEdgeBrowser(window.navigator.userAgent)) {
                goTo('help-notifications')

            } else {
                pushService.promptForNotificationPermission()
                closeAlertBar()
            }
        }
    }

    const goTo = (loc: string) => {
        if (loc === 'changelog') {
            window.open(Links.helpCenter, '_blank')
        } else if (loc === 'help-notifications') {
            window.open(Links.helpCenterNotifications, '_blank')
        }
    }

    const setAskNotificationPermissionStatus = () => {
        // this sets to local storage. if 'never' we won't ask for permission again
        localStorage.setItem('notPerm', 'never')
        closeAlertBar()
    }

    const defineMessage = () => {
        let color, message
        switch (type) {
            case 'default':
                message = (
                    <div>
                        <Icon name="flag" className="pe-2" /> Evertel needs your permission to enable desktop notifications
                        <Button color="dark" className="py-0 ms-2" onClick={enableNotifications}>Enable Notifications</Button>
                    </div>
                )
                color = 'warning'
                break
            case 'denied':
                message = (
                    <>
                        <div>
                            <Icon name="flag" className="me-2" /> We strongly recommend enabling notifications if you'll be using Evertel on this computer.
                        </div>
                        <div className="">
                            <Button color="primary" className="py-0 m-2" onClick={enableNotifications}>Enable Notifications</Button>
                            <Button color="dark" className="py-0 m-2" onClick={setAskNotificationPermissionStatus}>Never ask on this computer</Button>
                        </div>
                    </>
                )
                color = 'danger'
                break
            default:
                break
        }


        setMessage(message)
        setColor(color)
    }

    return (
        <HeaderAlert isOpen={isOpen} color={color} onClick={() => closeAlertBar()}>
            {message}
        </HeaderAlert>
    )
})

export { PermissionAlert }
